import {
    CLEAR_SELECTED_COUNTRY,
    COUNTRIES_ATC_PERCENTAGES_FETCH,
    COUNTRIES_FETCH_SUCCESSFULLY,
    COUNTRY_STATISTICS_FETCH_SUCCESSFULLY,
    COUNTRY_TIMELINE_LOAD,
    COUNTRY_TIMELINE_LOAD_SUCCESS,
    COVERED_COUNTRIES_FETCH_SUCESSFULLY,
    OPPONENT_COUNTRY_STATISTICS_FETCH_SUCCESSFULLY
} from "../actions/actionTypes";

const countryReducer = (state = {}, action) => {
    switch (action.type) {
        case COVERED_COUNTRIES_FETCH_SUCESSFULLY:
            return {
                ...state,
                coveredCountries: action.payload
            };
        case COUNTRY_STATISTICS_FETCH_SUCCESSFULLY:
            return {
                ...state,
                statistics: action.payload
            };
        case OPPONENT_COUNTRY_STATISTICS_FETCH_SUCCESSFULLY:
            return {
                ...state,
                opponentCountryStatistics: action.payload
            };
        case CLEAR_SELECTED_COUNTRY:
            return {
                ...state,
                opponentCountryStatistics: null,
                companyOpponentStatistics: null
            };
        case COUNTRY_TIMELINE_LOAD:
            return {
                ...state,
                loading: true
            };
        case COUNTRY_TIMELINE_LOAD_SUCCESS:
            return {
                ...state,
                loading: false,
                timeline: action.payload
            };
        case COUNTRIES_FETCH_SUCCESSFULLY:
            return {
                ...state,
                countries: action.payload
            };
        case COUNTRIES_ATC_PERCENTAGES_FETCH:
            return {
                ...state,
                countryAtcStatistics: action.payload
            }
        default:
            return state;
    }
};

export default countryReducer;
